import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import DropdownMenu from '../../common/Dropdown.jsx';
import { FaIcon } from '../../common/Icons.jsx';
import { fetchJson } from '../../../helpers/fetch.js';
import useMatchRegistryChannel from './useMatchRegistryChannel.js';
import ThinProgressBar from '../../task/datagrid/ThinProgressBar.jsx';
import LoadingIndicator from '../../common/loading_indicator.jsx';

import {
  match_baskets_path,
  match_basket_run_comparison_path,
  datagrid_show_match_basket_path
} from '~/routes';

function RunComparisonsLink({ datagridId, comparisonState, setComparisonState }) {
  const handleClick = async () => {
    await fetchJson(match_basket_run_comparison_path({datagrid_id: datagridId}), {method: 'POST'});
    setComparisonState({progress: 0, status: 'in_progress'});
  }

  return (
    <li className='dropdown-item'>
      <a
        className='no-style cursor-pointer'
        onClick={handleClick}
        style={{display: 'flex', gap: 5, alignItems: 'center'}}
      >
        <FaIcon type='sync' />
        <span>{I18n.t('run_comparison')}</span>
        <ProgressBar datagridId={datagridId} progress={comparisonState.progress} setComparisonState={setComparisonState} />
      </a>
    </li>
  )
}

function ProgressBar({datagridId, progress, setComparisonState}) {
  useMatchRegistryChannel(datagridId, setComparisonState);

  return progress !== null && <ThinProgressBar percentage={progress} style={{width: 100}} />
}

function BasketsDropdown({ datagridId }) { 
  const [comparisonState, setComparisonState] = useState({progress: null, status: 'not_started'});

  const { data, refetch } = useQuery({
    queryKey: ['match_baskets', datagridId],
    queryFn: () => fetchJson(match_baskets_path({ datagrid_id: datagridId })),
    enabled: true,
    staleTime: 30_000
  });

  useEffect(() => {
    if (comparisonState.status === 'done') {
      refetch();
    }
  }, [comparisonState?.status])

  return (<>
  {(data && data.length > 0) &&
    <DropdownMenu
      btnType='default'
      btnStyle={{maxHeight: '100%'}}
      label={<>
        {comparisonState.status === 'in_progress'
          ? <span><LoadingIndicator size='icon' /></span>
          : <FaIcon type='comments' />}
        {I18n.t('match_baskets')}
        <FaIcon type='caret-down' />
      </>}
      containerClass='column-selector d-inline-block'
    >
      {<RunComparisonsLink datagridId={datagridId} comparisonState={comparisonState} setComparisonState={setComparisonState} />}
      {(data || []).map((t) => (
        <li key={t.id} className='dropdown-item'>
          <a
            className='no-style cursor-pointer'
            href={datagrid_show_match_basket_path({match_basket_id: t.id, id: datagridId, _options: true})}
          >
            {t.name} ({t.entry_count})
          </a>
        </li>
      ))}
    </DropdownMenu>}
  </>)
}

export default BasketsDropdown;